import { appThemes } from "../env";
import { theme } from "../components/templates/ui";
export { appThemes };
export const appStyles = {
    invoned: {
        primary: theme.invoned.primary.base,
        primaryHover: theme.invoned.primary.hover,
        secondary: theme.invoned.secondary.base,
        secondaryHover: theme.invoned.secondary.hover,
        tertiary: theme.invoned.tertiary.base,
        tertiaryHover: theme.invoned.tertiary.hover,
        overlay: theme.invoned.tertiary.base,
        overlayOpacity: "0.85",
        logo: "/img/invoned-logo.png",
        textBase: theme.invoned.text.base,
        textLight: theme.invoned.text.light,
        textDark: theme.invoned.text.dark,
        grayDark: theme.invoned.gray.dark,
        grayBase: theme.invoned.gray.base,
        grayLight: theme.invoned.gray.light,
        border: theme.invoned.border.base,
        borderHover: theme.invoned.border.hover,
        fontBase: theme.invoned.font.base,
        fontHead: theme.invoned.font.head,
    },
};
export const baseAppStyle = {
    primary: theme.inkassier.primary.base,
    primaryHover: theme.inkassier.primary.hover,
    secondary: theme.inkassier.secondary.base,
    secondaryHover: theme.inkassier.secondary.hover,
    tertiary: theme.inkassier.tertiary.base,
    tertiaryHover: theme.inkassier.tertiary.hover,
    overlay: theme.inkassier.tertiary.base,
    overlayOpacity: "0.75",
    logo: "/img/inkassier-logo.png",
    textBase: theme.inkassier.text.base,
    textLight: theme.inkassier.text.light,
    textDark: theme.inkassier.text.dark,
    grayDark: theme.inkassier.gray.dark,
    grayBase: theme.inkassier.gray.base,
    grayLight: theme.inkassier.gray.light,
    border: theme.inkassier.border.base,
    borderHover: theme.inkassier.border.hover,
    fontBase: theme.inkassier.font.base,
    fontHead: theme.inkassier.font.head,
};
